export default __webpack_public_path__ + "static/media/Ocean 1.4e3a6862.png";